"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("../../utils/styled-components"));
var ShipmentDetails32 = function (props) { return (react_1.default.createElement("svg", __assign({ viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
    react_1.default.createElement("defs", null,
        react_1.default.createElement("path", { d: "M8.703 9.716a.5.5 0 01.452-.892l.57.289a.5.5 0 01.275.446V20.5a.5.5 0 01-.718.45l-9-4.36A.5.5 0 010 16.14V5a.5.5 0 01.726-.446l6.75 3.419a.5.5 0 11-.453.892L1 5.814v10.013l8 3.875V9.866l-.297-.15zm2.964-1.695a.5.5 0 01.415.91L10 9.881v9.856l3.17-1.382a.5.5 0 01.399.917l-3.87 1.686A.5.5 0 019 20.5V9.559a.5.5 0 01.293-.455zM20 5v7.5a.5.5 0 11-1 0V5.77l-4.796 2.142A.5.5 0 0113.796 7l5.5-2.456A.5.5 0 0120 5zm0 7a7 7 0 110 14 7 7 0 010-14zm0 1a6 6 0 100 12 6 6 0 000-12zm.002 5.5c.353 0 .64.277.64.641v2.94a.639.639 0 01-.545.634l-.095.007a.634.634 0 01-.64-.641v-2.94c0-.322.235-.588.545-.634l.095-.007zm-.002-3c.552 0 1 .459 1 1.024 0 .566-.448 1.025-1 1.025s-1-.459-1-1.025c0-.565.448-1.024 1-1.024zM10.703.543l9 4a.5.5 0 01-.406.914L10.49 1.543l-1.55.618 7.784 3.892A.5.5 0 0117 6.5v4a.5.5 0 01-.314.464l-2.5 1a.5.5 0 01-.686-.464V7.809L5.199 3.658.686 5.464a.5.5 0 01-.372-.928l7.397-2.96.013-.023.02.01 2.57-1.027a.5.5 0 01.39.007zM7.7 2.658l-1.258.503 7.783 3.892a.5.5 0 01.276.447v3.261l1.5-.6V6.81L7.699 2.658z", id: "shipment-details-32_svg__a" })),
    react_1.default.createElement("g", { transform: "translate(3 3)", fill: "currentColor", fillRule: "evenodd" },
        react_1.default.createElement("mask", { id: "shipment-details-32_svg__b" },
            react_1.default.createElement("use", { xlinkHref: "#shipment-details-32_svg__a" })),
        react_1.default.createElement("use", { fillRule: "nonzero", xlinkHref: "#shipment-details-32_svg__a" }),
        react_1.default.createElement("g", { mask: "url(#shipment-details-32_svg__b)" },
            react_1.default.createElement("path", { d: "M-3-3h32v32H-3z" }))))); };
var StyledShipmentDetails32 = styled_components_1.default(ShipmentDetails32)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: ", ";\n  height: ", ";\n  color: ", ";\n  vertical-align: middle;\n  fill: ", ";\n\n  ", "\n"], ["\n  width: ", ";\n  height: ", ";\n  color: ", ";\n  vertical-align: middle;\n  fill: ", ";\n\n  ", "\n"])), function (_a) {
    var _b = _a.size, size = _b === void 0 ? '32px' : _b;
    return size;
}, function (_a) {
    var _b = _a.size, size = _b === void 0 ? '32px' : _b;
    return size;
}, function (_a) {
    var color = _a.color, theme = _a.theme;
    return color || theme.base.color.text;
}, function (_a) {
    var color = _a.color, theme = _a.theme;
    return color || theme.base.color.text;
}, function (_a) {
    var stroke = _a.stroke;
    return stroke && "stroke: " + stroke + "; stroke-width: 64;";
});
exports.default = StyledShipmentDetails32;
var templateObject_1;
//# sourceMappingURL=ShipmentDetails32.js.map